import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { OTP_ACTION } from '@app/models';
import { DeveloperService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { Router } from '@angular/router';

@Component({
   selector: 'mnf-modal-confirm-resources',
   templateUrl: './modal-confirm-resources.component.html',
   styleUrls: ['./modal-confirm-resources.component.scss']
})
export class ModalConfirmResourcesComponent implements OnInit {
   // Información de los recursos a aceptar
   infoAmount: any;
   // Definir IVA
   iva: string;
   // Monto a retirar
   amountToWithdraw: string;
   // Comisión
   commisionTotal: string;
   // IVA
   ivaTotal: string;
   // Monto neto
   amountNetFinal: string;
   // Monto a monific
   amountToMonific: string;
   // Comisión por retiro
   percentCommission: string;
   // Veces aceptado los recursos
   totalAccepted: number;
   // Comisión
   commission: string;

   public readonly urlBaseS3 = 'https://static.monific.com/assets/projects-images/';

   constructor(
      private dialogRef: MatDialogRef<any>,
      private modalServ: ModalService,
      private devServ: DeveloperService,
      private toastServ: ToastrService,
      private router: Router
   ) { }

   ngOnInit(): void {
      this.devServ.getAllResourcesAccepted(this.infoAmount.pid).subscribe(r => {
         this.commission = r.commission;
         this.amountToWithdraw = r.amount;
         this.commisionTotal = r.totalCommission;
         this.percentCommission = r.withdrawCommission;
         this.ivaTotal = r.iva;
         this.amountToMonific = r.totalCommission;
         this.amountNetFinal = r.total;
      })
   }

   openModalAcceptResources() {
      this.modalServ.sendAndOpenModalOTP(OTP_ACTION.ACCEPT_RESOURCES, {
         title: ' Aceptar recursos', message: '', header: 'Confirmación de recursos'
      }).subscribe(token => {
         if (token) this.acceptResources(token);
      });

   }

   /** Función para aceptar los recursos */
   acceptResources(token: string): void {
      let textInfo: string = '';

      if (this.totalAccepted === 1) {
         textInfo = `Inversión efectiva (${this.totalAccepted}): ${this.infoAmount.name}`
      } else {
         textInfo = `Inversión efectiva (${this.totalAccepted + 1}): ${this.infoAmount.name}`
      }

      this.devServ.acceptResource(this.infoAmount.pid, token).subscribe(r => {
         if (r) {
            this.toastServ.success('Recursos aceptados correctamente', 'Aviso')
            this.dialogRef.close(true);
            setTimeout(() => {
               window.location.reload();
            }, 1000)
         } else {
            this.toastServ.warning('Se encontraron prblemas al aceptar los recursos', 'Aviso');
         }
      });
   }

   buildImageUrl(dev: any, urlBaseS3: string): string {
      let basePath = dev?.baseProject == null ? dev?.pid : dev?.baseProject;
      let imageUrl = dev?.image;
      
      if (!imageUrl) {
        return '';
      }
    
      let fullUrl = urlBaseS3 + basePath + '/' + imageUrl;
      let urlParts = fullUrl.split("https://static.monific.com/assets/");
      if (urlParts.length > 2) {
        fullUrl = "https://static.monific.com/assets/" + urlParts.pop();
      }
    
      return fullUrl;
    }

   /** Función para cerrar el modal actual */
   close() {
      this.toastServ.warning('Operación cancelada', 'Aviso')
      this.dialogRef.close();
   }

}
